<ul>
  <li *ngFor="let topic of inputMetadata;">
    {{topic?.description}} ({{topic?.toolName}})
  </li>
</ul>
